import { render, staticRenderFns } from "./SyncStatusConfirmButtonContainer.vue?vue&type=template&id=835f92dc&"
import script from "./SyncStatusConfirmButtonContainer.vue?vue&type=script&lang=js&"
export * from "./SyncStatusConfirmButtonContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports